goog.provide("shadow.js.shim.module$$js_joda$locale_en_us");
goog.provide("module$shadow_js_shim_module$$js_joda$locale_en_us");
shadow.js.shim.module$$js_joda$locale_en_us = shadow.js.nativeProvides["@js-joda/locale_en-us"] = shadow$bridge("@js-joda/locale_en-us");
module$shadow_js_shim_module$$js_joda$locale_en_us.default = shadow.js.shim.module$$js_joda$locale_en_us;
